module.exports = __webpack_public_path__ + "img/title_text@x.ba10ca32.png";